import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Layout } from "../pages/landing/Layout";
import { Loader } from "../components/Loader";
import { SellFaq } from "../sections/SellFaq";
import { FeatureImageLeft } from "../sections/FeatureImageLeft";
import { FeatureImageRight } from "../sections/FeatureImageRight";
import { CallToAction } from "../sections/CallToAction";
import { ProductImageBanner } from "../sections/product_image/ProductImageBanner";
import { ProductImageHow } from "../sections/product_image/ProductImageHow";
import { PatternDiscover } from "../sections/pattern/PatternDiscover";

export const product_image_generator_faq_data = [
    {
        question: "Can my original product photo has background?",
        answer: "Yes, your original product photo can have a background. You can upload your product photo with a background and our product image generator will remove the background and generate a professional-looking product image.",
    },
    {
        question:
            "Can I use the generated product image for commercial purposes?",
        answer: "Yes, you can use the generated product image for commercial purposes. You can use the generated product image in your online store, social media, or any other platform.",
    },
    {
        question: "What output formats are available?",
        answer: "We offer the following output formats: PNG, JPEG, and WEBP.",
    },
    {
        question: "What about privacy? Are my product photos safe?",
        answer: "Yes, your images are safe with us. Patternful.ai prioritizes user data safety. Your images are always private, proprietary, and they remain your property. All your uploaded images are automatically deleted from our servers after a few hours.",
    },
];

class ProductImageLanding extends Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: true };
    }
    componentDidMount() {
        this.setState({ isLoading: false });
    }

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return (
            <Layout>
                <Helmet>
                    <title>Product Image Generator</title>
                    <meta
                        name="description"
                        content="Generate product images in various styles."
                    />
                    <meta
                        name="keywords"
                        content="Product Image Generator, AI Product Image Generator, Product Image Generator APP, Product Image Online Generator, Image Processing, AI Image Editing, Patternful, Patternful AI"
                    />
                </Helmet>
                <ProductImageBanner />
                <ProductImageHow />
                <FeatureImageLeft
                    image={"/images/product-image/skin.webp"}
                    title={"Various Styles"}
                    description={
                        "Our product image generator creates professional, eye-catching visuals in just seconds. From sleek and minimalistic to bold and vibrant, it effortlessly adapts to any style you need."
                    }
                />
                <FeatureImageRight
                    image={"/images/product-image/furniture.webp"}
                    title={"Automatic Adjustments"}
                    description={
                        "Our product image generator automatically adjusts the product image to ensure it is the perfect size and position for your online store. It also removes any unwanted elements from the image to ensure it is a professional-looking product image."
                    }
                />
                <FeatureImageLeft
                    image={"/images/product-image/mug.webp"}
                    title={"Showcase with Models"}
                    description={
                        "Our product image generator lets you showcase your products with models in different styles or settings. Instantly create stunning, lifelike images with customizable backgrounds that bring your product to life."
                    }
                />
                <CallToAction
                    title={"Upload to Generate Product Images"}
                    subtitle={
                        "It has never been this easy to generate professional product images! Simply upload your product photo and let our product image generator do the work. "
                    }
                    link={"/product-image-generator/app"}
                    cta={"Get Started Now"}
                />
                <SellFaq data={product_image_generator_faq_data} />
                <PatternDiscover />
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return { userAccount: state.authReducer?.userAuth.userAccount };
}

export default connect(mapStateToProps, {})(withRouter(ProductImageLanding));
